/* eslint-disable react/prop-types */
import React from 'react';
// components
import { FormattedMessage } from 'react-intl';
import { CustomColumn } from 'components/DataTable/Columns/index';
import errorColumn from '../ErrorColumn';
// utils
import cn from 'classnames';

// Error codes with their own message; any other code is a failing farm attribute
const farmRowErrors = ['name', 'unexpected'];

const renderFarmNameColumn = ({ formatted_row, name, error }) => (
  <CustomColumn
    label={<FormattedMessage id="component.dataTable.headers.farmName" />}
    className={cn({ 'highlighted': error === 'name' })}
  >
    {formatted_row?.name || name || '-'}
  </CustomColumn>
);

const renderFarmAddressColumn = ({ formatted_row, address, error }) => (
  <CustomColumn
    label={<FormattedMessage id="general.address" />}
    className={cn({ 'highlighted': error === 'address' })}
  >
    {formatted_row?.address || address || '-'}
  </CustomColumn>
);

const renderPremiseIdColumn = ({ formatted_row, federal_premise_id, error }) => (
  <CustomColumn
    label={<FormattedMessage id="general.premiseId" />}
    className={cn({ 'highlighted': error === 'federal_premise_id' })}
  >
    {formatted_row?.federal_premise_id || federal_premise_id || '-'}
  </CustomColumn>
);

const renderFarmIdColumn = ({ formatted_row, external_link_id, error }) => (
  <CustomColumn
    label={<FormattedMessage id="general.farmId" />}
    className={cn({ 'highlighted': error === 'external_link_id' })}
  >
    {formatted_row?.external_link_id || external_link_id || '-'}
  </CustomColumn>
);

const renderFarmTypeColumn = ({ formatted_row, farm_type, error }) => (
  <CustomColumn
    label={<FormattedMessage id="general.farmType" />}
    className={cn({ 'highlighted': error === 'farm_type' })}
  >
    {formatted_row?.farm_type || farm_type || '-'}
  </CustomColumn>
);

const farmColumns = (status) => ([
  { label: <FormattedMessage id="component.dataTable.headers.farmName" />, flex: '1 1 140px',
    renderer: renderFarmNameColumn, sortKey: 'farm_name' },
  { label: <FormattedMessage id="general.address" />, flex: '1 1 140px',
    renderer: renderFarmAddressColumn, sortKey: 'address' },
  { label: <FormattedMessage id="general.farmId" />, flex: '1 1 140px',
    renderer: renderFarmIdColumn, sortKey: 'external_link_id' },
  { label: <FormattedMessage id="general.premiseId" />, flex: '1 1 140px',
    renderer: renderPremiseIdColumn, sortKey: 'premise' },
  { label: <FormattedMessage id="general.farmType" />, flex: '1 1 140px',
    renderer: renderFarmTypeColumn, sortKey: 'farm_type' },
  ...(status === 'errors' ? [errorColumn(farmRowErrors)] : []),
]);

export default farmColumns;
